<script setup lang="ts">
interface Props {
  hasError?: boolean;
  stepper?: 'none' | 'plusminus';
}

const emit = defineEmits<{
  increment: [];
  decrement: [];
}>();

const { hasError = false, stepper = 'none' } = defineProps<Props>();
</script>

<template>
  <div
    class="flex items-center h-10 rounded-small border"
    :class="
      hasError
        ? 'bg-error-container border-error'
        : 'bg-grey-50 border-border-input'
    "
  >
    <slot />
    <template v-if="stepper === 'plusminus'">
      <div class="w-px h-10 bg-border-light" />
      <button
        type="button"
        class="w-8 h-10 flex items-center justify-center text-text-secondary hover:text-text-primary active:bg-grey-100 transition-colors"
        aria-label="Decrement"
        @click="emit('decrement')"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line x1="5" y1="12" x2="19" y2="12" />
        </svg>
      </button>
      <div class="w-px h-10 bg-border-light" />
      <button
        type="button"
        class="w-8 h-10 flex items-center justify-center text-text-secondary hover:text-text-primary active:bg-grey-100 transition-colors"
        aria-label="Increment"
        @click="emit('increment')"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line x1="12" y1="5" x2="12" y2="19" />
          <line x1="5" y1="12" x2="19" y2="12" />
        </svg>
      </button>
    </template>
  </div>
</template>
